<template>
  <div
    class="ba-relative ba-mt-4 ba-ml-20"
    :class="statusColor"
  >
    <div class="ba-absolute ba-right-full ba-inset-y-0 ba-w-7 ba-h-12 ba-mr-5 ba--mt-4 ba-border-l ba-border-b ba-border-current ba-rounded-bl-2xl" />
    <vis-approval-queue-task-header
      delegation-panel
      :item="item"
      :queue-type="queueType"
      :is-delegated="item.delegation"
      :progress-color="progressColor"
      :progress-width="progressWidth"
    />
  </div>
</template>

<script>
import visApprovalQueueTaskHeader from "./vis-approval-queue-task-header";

export default {
  name: 'vis-approval-queue-task-delegation-panel',
  components:{
    visApprovalQueueTaskHeader
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    queueType: {
      type: String,
      default: null
    },
    statusColor: {
      type: String,
      default: null
    },
    progressColor: {
      type: String,
      default: null
    },
    progressWidth: {
      type: String,
      default: null
    }
  }
}
</script>
